import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import api from '../../lib/api';
import Link from '../Link';

class ModeratorWelcomeBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasComplexes: null,
      loading: true,
    };
  }

  async componentDidMount() {
    if (this.props.userRole === 'moderator') {
      try {
        const status = await api.getModeratorStatus();
        this.setState({
          hasComplexes: status.hasComplexes,
          loading: false,
        });
      } catch (err) {
        console.error('Ошибка получения статуса менеджера:', err);
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    const { classes, userRole } = this.props;
    const { hasComplexes, loading } = this.state;

    if (loading || userRole !== 'moderator' || hasComplexes === null || hasComplexes) {
      return null;
    }

    return (
      <Paper className={classes.banner} elevation={2}>
        <Typography variant="h6" gutterBottom>
          Добро пожаловать в Playbase!
        </Typography>
        <Typography variant="body1" paragraph>
          Для начала работы создайте спортивный комплекс и площадки на нем.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Ваши спортивные комплексы и площадки будут доступны публично после модерации администратором.
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/new-center"
          >
            Создать спортивный комплекс
          </Button>
        </div>
      </Paper>
    );
  }
}

const styles = () => ({
  banner: {
    padding: 20,
    marginBottom: 20,
    backgroundColor: '#e3f2fd',
    borderLeft: '4px solid #2196f3',
  },
  buttonContainer: {
    marginTop: 15,
  },
});

const Styled = withStyles(styles)(ModeratorWelcomeBanner);

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
});

export default connect(mapStateToProps)(Styled);

